import React from 'react';
import SEOHelmet from '../SEOHelmet';

const PrithviViharPage: React.FC = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    //eslint-disable-next-line
  }, []);
  
  return (
    <div className='mt-28 mb-20 max-w-4xl mx-auto px-4'>
      <SEOHelmet />
      <h1 className='text-3xl md:text-5xl font-bold text-center mb-8'>Neurosurgical Consultations for Prithvi Vihar | Dr. Gangesh Gunjan</h1>
      
      <section className='my-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Specialized Neurosurgical Care for Prithvi Vihar Patients</h2>
        <p className='text-lg text-gray-700 leading-relaxed'>Dr. Gangesh Gunjan brings over 12 years of specialized clinical experience in cranial, spinal, and peripheral nerve surgery. Patients from Prithvi Vihar and surrounding Noida sectors can access consultations and advanced surgical care at the Department of Neurosurgery, Sarvodaya Hospital, Greater Noida West.</p>
      </section>

      <section className='my-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Specialized Neurosurgical Treatments</h2>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Minimally invasive brain and spine procedures (microdiscectomy, endoscopic skull base surgery)</li>
          <li>Surgical management of cranial tumors and gliomas</li>
          <li>Degenerative spine treatments including spinal decompression and fusion</li>
          <li>Evaluation of movement disorders and chronic pain pathways</li>
          <li>Peripheral nerve decompression (carpal tunnel release, sciatica management)</li>
        </ul>
      </section>

      <section className='my-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Clinical Expertise & Practice Focus</h2>
        <p className='text-lg text-gray-700 leading-relaxed'>With comprehensive post-graduate surgical training (MS General Surgery, M.Ch Neurosurgery) and fellowship training in neuroendoscopy, Dr. Gunjan utilizes evidence-based clinical protocols and precision microsurgical techniques to treat complex neurological conditions.</p>
      </section>

      <section className='my-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Neurological Conditions Evaluated</h2>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Brain tumors, pituitary adenomas, and skull base lesions</li>
          <li>Cervical and lumbar disc herniations, spinal canal stenosis</li>
          <li>Acute neurotrauma, head injuries, and vertebral fractures</li>
          <li>Trigeminal neuralgia and facial pain syndromes</li>
          <li>Congenital disorders including hydrocephalus and spinal dysraphism</li>
        </ul>
      </section>

      <section className='my-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Advanced Hospital Infrastructure</h2>
        <p className='text-lg text-gray-700 leading-relaxed'>Consultations and surgical procedures take place at Sarvodaya Hospital, Greater Noida West, which features high-resolution MRI and CT diagnostics, real-time neuronavigation, intraoperative neuromonitoring, and a dedicated Neuro-ICU for postoperative care.</p>
      </section>

      <section className='my-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Patient-Centered Care Pathway</h2>
        <p className='text-lg text-gray-700 leading-relaxed'>Clinical care emphasizes thorough preoperative counseling, transparent review of conservative versus operative choices, and structured follow-up rehabilitation to support optimal functional recovery for every patient.</p>
      </section>

      <section className='my-8 bg-blue-50 p-6 rounded-2xl border border-blue-100'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-3 text-blue-900'>Contact for Consultation</h2>
        <p className='text-lg text-gray-700 leading-relaxed mb-4'>
          To schedule a neurosurgical consultation with Dr. Gangesh Gunjan, please call{' '}
          <a href="tel:+917727834367" className='text-blue-600 font-semibold hover:underline'>+91-7727834367</a>{' '}
          or visit Room no. 1011, Sarvodaya Hospital, Sector 16C, Gaur City 2, Greater Noida West.
        </p>
      </section>
    </div>
  );
};

export default PrithviViharPage;